var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.643279212,0.112270429 L0.112607577,0.642604915 C-0.0387720699,0.793984562 -0.0364120309,1.0336971 0.112607577,1.18271671 L10.2796558,11.3511135 C10.4296868,11.5008074 10.6707479,11.5001331 10.8197675,11.3507763 L11.350102,10.8204418 C11.5018188,10.6690622 11.4994588,10.4293497 11.3504392,10.2803301 L1.183391,0.11193328 C1.10854405,0.0370863277 1.01110815,0 0.913672256,0 C0.81589921,0 0.717789016,0.0374234762 0.643279212,0.112270429 L0.643279212,0.112270429 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Btn150-/-Tags-/-material",
    transform: "translate(-369.000000, -12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-:-Cross/close",
    transform: "translate(369.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-21"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0.818789054,
    y1: 0.818789054,
    x2: 10.6442577,
    y2: 10.6442577,
    id: "Stroke-23",
    stroke: "#34495E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.6442577,
    y1: 0.818789054,
    x2: 0.818789054,
    y2: 10.6442577,
    id: "Stroke-25",
    stroke: "#34495E",
    strokeLinecap: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ad3d580c012161936fb849beb3e2fe05.svg";
export { ForwardRef as ReactComponent };